<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<mat-card
  *ngIf="!isLoading"
  class="full-content"
>
  <mat-card-title class="content-header">{{ customerName }} </mat-card-title>

  <mat-card-content class="content">
    <div style="margin-top: 0; margin-bottom: 20px; margin-left: 20px; margin-right: 20px">
      <app-carousel [screenType]="screenType"></app-carousel>
    </div>

    <!-- <mat-card
      id="login-feature-banner"
      class="section-card"
      style="background-color: orange; text-align: center"
    >
      <div>
        ALERT: Users can now login/register and see complete order history.

        <a
          style="margin-left: 1rem"
          href="/login"
        >
          Login Page
        </a>

        <span style="margin-left: 1rem">( customers.zippmat.in )</span>
      </div>
    </mat-card> -->

    <mat-card
      id="enquiry-details"
      class="section-card"
    >
      <mat-card-title class="section-header">Enquiry Details</mat-card-title>

      <mat-card-content class="grid-display-3 no-padding">
        <div class="grid-display-3">
          <p>Enquiry Number:</p>
          <p style="grid-column: span 2">
            <b>
              {{ enquiryBasicData.enquiryNum }}
            </b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Enquiry Date:</p>
          <p style="grid-column: span 2">
            <b>{{ enquiryBasicData.enquiryDate }}</b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Relationship Manager:</p>
          <p style="grid-column: span 2">
            <b>{{ relationshipManagerData.name }}</b>
          </p>
        </div>

        <div
          class="grid-display-6"
          style="grid-column: span 2"
        >
          <p>Delivery Address:</p>
          <p style="grid-column: span 4">
            <b>{{ enquiryBasicData.deliveryAddress }}</b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Delivery PIN Code:</p>
          <p style="grid-column: span 2">
            <b>{{ enquiryBasicData.deliveryPincode | pincodeNumberFormat }}</b>
          </p>
        </div>

        <app-report-issue-button
          [entityId]="customerOrderId"
          [entityType]="entityType"
          [isInternalUser]="isInternalUser"
          [contactNumberWhatsapp]="relationshipManagerData.mobile"
        />

        <div class="empty-cell"></div>

        <app-share-requirements-button [publicId]="publicRequirementsId"> </app-share-requirements-button>
      </mat-card-content>
    </mat-card>

    <mat-card
      id="requirement-items"
      class="section-card normal-text"
    >
      <mat-card-title class="section-header">Requirement Items</mat-card-title>

      <div class="scroll-x-container">
        <table
          mat-table
          [dataSource]="orderItemDataSource"
        >
          <ng-container
            matColumnDef="category"
            [sticky]="true"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Category </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.category }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Product </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.product }}
            </td>
          </ng-container>

          <ng-container matColumnDef="make">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Make </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.make }}
            </td>
          </ng-container>

          <ng-container matColumnDef="grade">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Grade </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.grade }}
            </td>
          </ng-container>

          <ng-container matColumnDef="brand">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Brand </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.brand }}
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Type </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.type }}
            </td>
          </ng-container>

          <ng-container matColumnDef="property">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Property </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.property }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dimension">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Dimension </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.dimension }}
            </td>
          </ng-container>

          <ng-container matColumnDef="customDimensions">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Custom Dimensions </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.customDimensions }}
            </td>
          </ng-container>

          <ng-container matColumnDef="qty">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Quantity </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.qty }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="requirementItemColumns"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: requirementItemColumns"
            class="mat-row"
          ></tr>
        </table>
      </div>
    </mat-card>

    <mat-card
      id="quotes"
      class="section-card"
    >
      <mat-card-title class="section-header">Quotes </mat-card-title>

      <div
        *ngFor="let row of quotationList; let i = index"
        class="grid-display-6"
      >
        <p>{{ row.quotationNum }}</p>

        <app-file-download-button [fileUrl]="row.quotationPdfUrl"> </app-file-download-button>

        <p style="grid-column: span 3">{{ row.quotationMessage }}</p>
      </div>
    </mat-card>

    <mat-card
      id="invoices"
      class="section-card"
    >
      <mat-card-title class="section-header">Invoices</mat-card-title>

      <p style="font-weight: 600; color: green; margin-bottom: 2rem">
        NOTE: For documents related to invoices, such as the Material Test Certificate and GRN, please log in to the

        <a
          href="/login"
          target="_blank"
        >
          Customer Portal
        </a>
      </p>

      <div class="grid-display-6">
        <ng-container *ngFor="let row of invoiceList; let i = index">
          <p>{{ row.invoiceNum }}</p>

          <app-file-download-button [fileUrl]="row.customerInvoiceUrl"> </app-file-download-button>

          <div class="chips">
            <mat-chip
              class="status-chip"
              [ngClass]="getInvoiceStatusChipClass(row.invoiceStatus)"
            >
              {{ row.invoiceStatus.value }}
            </mat-chip>
          </div>

          <div
            class="empty-cell"
            style="grid-column: span 3"
          ></div>
        </ng-container>
      </div>
    </mat-card>

    <mat-card
      id="relationship-manager"
      class="section-card"
    >
      <mat-card-title class="section-header">Relationship Manager</mat-card-title>

      <p>
        <b>{{ relationshipManagerData.name }}</b>
      </p>

      <div class="grid-display-12">
        <p>Email:</p>
        <p style="grid-column: span 5">{{ relationshipManagerData.email }}</p>

        <p>Mobile:</p>
        <p style="grid-column: span 5">{{ relationshipManagerData.mobile | mobileNumberFormat }}</p>
      </div>
    </mat-card>
  </mat-card-content>
</mat-card>
